import React, { ReactElement, useContext, useEffect, useState } from 'react';
import { FieldRendererProps } from '../FieldTableTypes';
import { FieldTableSettingsContext } from '../../../contexts/field-table-settings-context';
import { ToggleButtonGroup, ToggleButton } from "@mui/material";
import PhotoPaidIcon from '../../../handlers/campaigns/panes/PhotoPaidIcon';
import PhotoNotPaidIcon from '../../../handlers/campaigns/panes/PhotoNotPaidIcon';
import { styled } from "@mui/system";

const ActiveToggleButton = styled(ToggleButton)(({ theme }) => ({
    color: "#fff",
    "&.Mui-selected": {
      backgroundColor: "#93bedf", 
      color: "#ffffff", 
    },
  }));

export function ToggleButtonGroupField(props: FieldRendererProps<any>): ReactElement {
    const [alignment, setAlignment] = useState(props.field.value ? (props.field.value == 1 ? '1' : '0') : '');

    const handleChange = (
      event: React.MouseEvent<HTMLElement>,
      newAlignment: string,
    ) => {
        setAlignment(newAlignment);
        if (props.field.readOnly) return;
        props.field.setValue(props.field.name, (v) => { return newAlignment; });
    };

    return (
        <ToggleButtonGroup
            color="primary"
            value={alignment}
            exclusive
            onChange={handleChange}
            aria-label="Platform"
        >
            <ActiveToggleButton value="0"><PhotoNotPaidIcon/></ActiveToggleButton>
            <ActiveToggleButton value="1"><PhotoPaidIcon/></ActiveToggleButton>
        </ToggleButtonGroup>
    );
}

export function FieldTableBooleanCamToggleColumn(): ReactElement {
    const context = useContext(FieldTableSettingsContext);

    useEffect(() => {
        if (!context) return;
        context.registerType({
            dataType: 'booleanCamToggle',
            width: () => 'minmax(8em,max-content)',
            className: () => 'column-centered column-button with-border',
            renderViewer: (props: FieldRendererProps<any>) => {
                const fieldValue = props.options?.getValue ? props.options.getValue(props) : props.field.value;
                return <ToggleButtonGroupField field={props.field} />;
            },
            renderEditor: (props: FieldRendererProps<any>) => {
                const fieldValue = props.options?.getValue ? props.options.getValue(props) : props.field.value;
                return <ToggleButtonGroupField field={props.field} />;
            },
            renderExport: (cell, props: FieldRendererProps<any>): any => {
                const fieldValue = props.options?.getValue ? props.options.getValue(props) : props.field.value;
                cell.v = fieldValue === 'Y' ? 'Y' : 'N';
                return cell;
            }
        });
    }, [context]);

    return null;
}
